import {call, put, takeLatest} from 'redux-saga/effects'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from '..'
import {actionTypes} from './constants'
import {service} from './service'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'

function* getClients() {
  try {
    const response: ResponseModel = yield call(service.getClients)
    yield put(actions.getClientsSuccess(response?.data?.data))
    yield put(actions.getClientsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getClientsFinish(err))
  }
}

function* createClient(action: ActionModel) {
  try {
    const response: ResponseModel = yield call(service.createClient, action.payload as any)
    yield put(actions.createClientSuccess(response?.data?.data))
    yield put(actions.createClientFinish())
  } catch (err: any) {
    // Do NOT dispatch GLOBAL_ERROR here — 422 field errors are surfaced inline
    // by the drawer via state.oauthClients.createError.
    yield put(actions.createClientFinish(err))
  }
}

function* revokeClient(action: ActionModel) {
  try {
    const response: ResponseModel = yield call(service.revokeClient, action.payload as any)
    yield put(actions.revokeClientSuccess(response?.data?.data))
    yield put(actions.revokeClientFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.revokeClientFinish(err))
  }
}

function* deleteClient(action: ActionModel) {
  try {
    const response: ResponseModel = yield call(service.deleteClient, action.payload as any)
    yield put(actions.deleteClientSuccess(response?.data?.data))
    yield put(actions.deleteClientFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteClientFinish(err))
  }
}

function* getTokens(action: ActionModel) {
  try {
    const response: ResponseModel = yield call(service.getTokens, action.payload as any)
    yield put(actions.getTokensSuccess(response?.data?.data))
    yield put(actions.getTokensFinish())
  } catch (err: any) {
    yield put(actions.getTokensFinish(err))
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_OAUTH_CLIENTS_REQUEST, getClients)
  yield takeLatest(actionTypes.CREATE_OAUTH_CLIENT_REQUEST, createClient)
  yield takeLatest(actionTypes.REVOKE_OAUTH_CLIENT_REQUEST, revokeClient)
  yield takeLatest(actionTypes.DELETE_OAUTH_CLIENT_REQUEST, deleteClient)
  yield takeLatest(actionTypes.GET_OAUTH_TOKENS_REQUEST, getTokens)
}
